import React from 'react';

export default function StockOnHandTable() {
	return (
		<div className="table-view table-responsive">
			<table id="sales-quotes-charge-table" className="table">
				<thead>
					<tr>
						<th>Product Code</th>
						<th>Product Description</th>
						<th>Warehouse</th>
						<th>Sale Days</th>
						<th>Price Tier</th>
						<th>On Purchase</th>
						<th>Quantity On Hand</th>
						<th>Alloacted Quantity</th>
						<th>Available Quantity</th>
						<th>Avg Cost</th>
						<th>Total Cost</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
		</div>
	);
}
